import { cloneElement, FC, isValidElement } from 'react';
import { TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import classNames from 'classnames';
import { CustomHeaderCellProps } from '../../../types';
import { COLUMN_NAMES } from '../../../constants/columnNames';
import InfoPopover from 'shared/components/andtComponents/InfoPopover';

import styles from '../GovernanceTagsTableController.module.scss';
import tooltipStyles from '../../../../shared/components/andtComponents/Tooltip.module.scss';

export const CustomHeaderCell: FC<CustomHeaderCellProps> = ({ column, children, tableColumn, ...restProps }) => {
  const { title, headerClassName } = column;
  const showHeader = Boolean(title);
  const isFixedRight = tableColumn.fixed === 'right';
  const isResourceCostColumn = column.name === COLUMN_NAMES.RESOURCE_COST;

  const childrenArray = Array.isArray(children) ? children : [children];
  const childrenWithKeys = childrenArray.map((child, index) => {
    if (isValidElement(child)) {
      return child.key ? child : cloneElement(child, { key: `header-child-${index}` });
    }
    return child;
  });

  const HeaderContent = (
    <>
      {childrenWithKeys}
      {isResourceCostColumn ? (
        <InfoPopover
          key="resource-cost-info"
          placement="top"
          mode="outline"
          className={{
            icon: styles.infoIcon,
            tooltip: tooltipStyles.whiteTooltip,
            arrow: tooltipStyles.whiteArrow,
          }}
        >
          Last 30 Days
        </InfoPopover>
      ) : null}
    </>
  );

  return (
    <TableHeaderRow.Cell
      {...restProps}
      column={column}
      tableColumn={tableColumn}
      className={classNames(styles.headerCell, headerClassName)}
      {...(isFixedRight ? { 'data-fixed-column': 'right' } : {})}
    >
      {showHeader ? (
          <span className={styles.headerCellContent}>{HeaderContent}</span>
      ) : null}
    </TableHeaderRow.Cell>
  );
};
